import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Optional, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, ActivationEnd, NavigationEnd, Router, UrlSegment } from '@angular/router';
import { AuthenticationService } from '@api/services/authentication.service';
import { azureConfigService } from '@api/services/azureconfig.service';
import { ConfigurationApiService } from '@api/services/configuration.service';
import { FooterService } from '@api/services/footer.service';
import { GroupService } from '@api/services/group.service';
import { HeaderService } from '@api/services/header.service';
import { playFreeService } from '@api/services/playFree.service';
import { UserApiService } from '@api/services/user.service';
import { FireBase } from '@classes/fireBase';
import { logEvent } from '@firebase/analytics';
import { loteriaEmpresaModel } from '@models/api-models/loteria_empresa.models';
import { Mygroup } from '@models/group.model';
import { MPerson } from '@models/person.model';
import { BetService } from '@modules/games/bet.service';
import { modalAlertaComponent } from '@shared/components/modals/modalAlerta/modalAlerta.component';
import { modalPinComponent } from '@shared/components/modals/modalPin/modalPin.component';
import { modalYesNoComponent } from '@shared/components/modals/modalYesNo/modalYesNo.component';
import { ToastrService } from 'ngx-toastr';
import { combineLatest, Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

/**
 * Component that represents the footer of the playbets module, it shows the cost of the bet and the button to play the bets
 */
@Component({
    selector: 'app-games-footer',
    templateUrl: './games-footer.component.html',
    styleUrls: [
        './games-footer.component.scss',
    ],
    standalone: false
})
export class GamesFooterComponent extends FireBase implements OnChanges, OnInit, OnDestroy {

	@Output() betEvent = new EventEmitter();
	@Input() cost: number = 0;
	guindaCostConfig: number = 0;
	guindaCost: number = 0;
	@Input() titlebutton: String = "Jugar";
	@Input() manual: Boolean = false
	@Input() donacion: number = null
	@Input() empresa: loteriaEmpresaModel;	
	@Output() clickEvent: EventEmitter<Boolean> = new EventEmitter()

	public disabled = false;
	public loading = false;
	public saldoCliente: number = 0;
	public grupo_id: number = 0;
	private sendMode: number = 1;
	public nombre_grupo: number;
	public activeClass = "activated-button";
	public saldo: number;
	public cliente_id: number = 0;
	public user: MPerson
	private freeBeet: Boolean = false
	public game_id: number = 0;
	public guinda: Boolean = false;
	public betNumbers = 0;

	private guindaSub: Subscription
	private guindaPriceSub: Subscription
	private optionsSub: Subscription

	constructor(
		protected betService: BetService,
		protected router: Router,
		protected activateRouter: ActivatedRoute,
		protected toastrService: ToastrService,
		protected playFreeService: playFreeService,
		protected dialog: MatDialog,
		protected userService: UserApiService,
		protected headerService: HeaderService,
		protected footerService: FooterService,
		protected grupoService: GroupService,
		protected authenticationService: AuthenticationService,
		protected configService: ConfigurationApiService,
		protected azureService: azureConfigService,
	) {
		super()
		this.cost = betService.cost;

		this.getUserInfo()
		footerService.set_Show_footer(false)

		this.userService.usuarioObservable.subscribe(res => {
			if (res)
				this.saldoCliente = res.client.getSaldoTotal()
		});

		betService.costObservable$.subscribe((newCost: number) => {

			this.cost = newCost;
		});

		betService.totalBetsObservable$.subscribe((res) => {
			this.betNumbers = res;
		})
	}

	ngOnInit(): void {
		this.modoGrupo();
		this.loadFreeBet();

		if (this.authenticationService.isAuthenticated())
			this.loadSaldoCliente();

		/*this.betService.addedDaysObservable$.subscribe((days) => {

			if (days.length <= 0 ){
				this.disabled = true;
			} else {
				this.disabled = false;
			}


		});*/

		this.betService.observablenumberBets.subscribe(res => {
			if( this.empresa && res < this.empresa?.compra_minima){
				this.disabled = true
				return;
			}
			if (res > 0 && !this.loading)
				this.disabled = false;
			else
				this.disabled = true;
		})

		this.guindaSub = this.betService.guindaObservable$.subscribe(res => { 
			this.guinda = res;
		})
	
		this.optionsSub = this.betService.optionsObservable$.subscribe((res: any) => {
			if (res.idGame != this.game_id) {
				this.game_id = res.idGame
			}
		});

		this.guindaPriceSub = combineLatest([
			this.betService.guindaPriceObservable$,
			this.betService.totalBetsObservable$
		]).subscribe(([guindaPrice, totalBets]) => {
			this.guindaCostConfig = guindaPrice;
			this.guindaCost = totalBets * this.guindaCostConfig;
		});

	}

	loadFreeBet() {
		this.betService.freeBetObservable$.subscribe(res => this.freeBeet = res)
	}

	getUserInfo() {
		this.userService.usuarioObservable.subscribe(res => {
			if (res)
				this.user = res
		})
	}

	modoGrupo() {
		if (this.activateRouter.snapshot.queryParams.grupo_id) {
			this.grupo_id = this.activateRouter.snapshot.queryParams.grupo_id;
			this.nombre_grupo = this.activateRouter.snapshot.queryParams.nombre;
			this.activeClass += " activated-button-grupo";
			this.headerService.set_modeGrupoCool(true);
			this.betService.setGrupoId(this.grupo_id);
		}

	}

	loadSaldoCliente() {
		if (!this.grupo_id) {
			this.userService.usuarioObservable.subscribe(res => {
				if (res) {
					this.saldoCliente = res.client.getSaldoTotal();
					this.cliente_id = res.client.id
				}
			});
		}
		else {
			this.grupoService.get_grupo(this.grupo_id).subscribe((res: Mygroup) => {
				this.saldoCliente = Number(res.saldo.saldo_tarjeta) + Number(res.saldo.saldo_premios) + Number(res.saldo.saldo_no_disponible);
			})
		}
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.cost != undefined) {
			const currentCost: SimpleChange = changes.cost;
			this.cost = currentCost.currentValue;
		}
	}

	autoingreso(sobrante) {
		let texto = "Esta jugada tiene un coste de:</br></br>";
		let coste = this.betService.cost;
		if (this.guinda) {
			coste += this.guindaCost
		}

		texto += "<h2 class='currency'>" + coste + " €</h2></br>";
		texto += "<span>Tienes el autoingreso activado. La cantidad mínima para completar el pedido será ingresada.</span>";
		let dialogAlert = this.dialog.open(modalAlertaComponent, {
			panelClass: 'modal-custom',
			data: {
				title: 'Confirmar jugada',
				texto: texto,
				buttonConfirm: 'Ingresar y pagar jugada',
				showOptionCheck: false
			}
		});
		dialogAlert.afterClosed().subscribe(res2 => {
			if (res2) {
				let ingresos = Math.ceil(Math.abs(sobrante) / this.user.client.autoingreso);
				let cant = ingresos * this.user.client.autoingreso;
				this.userService.ingresarDinero(cant, 0, 0, null).subscribe((res: any) => {
					if(res.status == 201){
						logEvent(this.analytics, "deposit");
						this.userService.setSaldo(this.user.client.getSaldoTotal() + Number(cant));
						this.playBetAux();
					} else {
						this.toastrService.error(res.u_message);
						this.betService.setLoading(false);
						this.loading = false;
						this.disabled = false;
					}
				});
			}
		});
	}

	saldoInsuficienteBet(sobrante: number) {
		if (!this.grupo_id && this.user.client.autoingreso != null && this.user.client.autoingreso > 0) {
			this.userService.getSeguridad().subscribe((res: any) => {
				if (res.status == 200) {
					if (res.data.compra_producto) {
						let checkPinDialog = this.dialog.open(modalPinComponent, {
							panelClass: 'modal-custom',
							disableClose: true,
							data: {
								'title': "Escribe tu PIN de Seguridad",
								'mode': "Check",
								'parameters': null
							}
						});
						return checkPinDialog.afterClosed().subscribe((res) => {
							if (res == true) {
								this.autoingreso(sobrante);
							}
						});
					}
					else {
						this.autoingreso(sobrante);
					}
				}
				else {
					this.autoingreso(sobrante);
					this.toastrService.error('Error al comprobar la seguridad del cliente');
				}
				return false;
			});
		}
		else {
			let texto = "No tienes suficiente saldo para realizar el pedido. Tendrás que cargar."
			let dialogAlert = this.dialog.open(modalYesNoComponent, {
				panelClass: 'modal-custom',
				data: {
					title: 'Upss!! Te falta saldo',
					texto,
					buttonConfirm: 'Cargar',
					buttonCancel: 'Cancelar',
					buttonConfirmColor: "blue",
					showIcon: false,
					showOptionCheck: false
				}
			});
	
			dialogAlert.afterClosed().subscribe(res => {
				if (res) {
					localStorage.setItem("url", this.router.url)
	
					if (this.betService.empresa != null) {
						localStorage.setItem("empresa", JSON.stringify({
							"empresa_id": this.betService.empresa.id,
							"bets": this.betService.bets,
							"envio_id": this.betService.sendMode != null ? this.betService.sendMode.id : 1,
							"slug": this.betService.empresa.slug,
							"importe": Number(this.betService.cost),
							"leguinda": this.betService.guinda,
							"guindaprice": Number(this.betService.guindaPrice) * this.betService.bets.length,
							"days": this.betService.empresa.sorteo_asociado.fecha
						}));
					}
					else {
						this.betService.saveBetData();
					}
	
					this.router.navigate(['/cliente/ingresar']);
				}
			});
		}
	}

	playBet(): void {
		if (!this.manual) {
			if (this.authenticationService.isAuthenticated()) {

				if (this.betService.empresa != null) {
					if (this.empresa.coderequired) {
						this.configService.codeOb.pipe(take(1)).subscribe(res => {
							if (res == null) {
								this.toastrService.error('Esta empresa requiere un código para entrar');
								this.router.navigate(['/']);
							}
						})
					}
					if (this.betService.empresa.azureadactive) {
						this.userService.azureloginObservable.subscribe(res => {
							let azureLogged = res.isValidUser(this.betService.empresa.id);
							if (!azureLogged) {
								this.azureService.updateAuthConfig(this.betService.empresa.tenant_id, this.betService.empresa.slug);
								this.loginAzure();
								return;
							}
						});
					}
					let nuevoSaldo = this.saldoCliente - this.betService.cost;
					if (this.guinda) {
						nuevoSaldo -= this.guindaCost;
					}
					if (nuevoSaldo < 0 || this.saldoCliente == 0) {
						// if (this.betService.sendMode) {
						// 	if (this.betService.sendMode.id > 1 && this.betService.sendMode.id != 5 && !this.betService.sendMode.sede) {
						// 		if (!this.user.adress || !this.user.city || !this.user.cp || !this.user.province || !this.user.phone) {
						// 			this.toastrService.error('Introduce los datos de envío');
						// 			return;
						// 		}
						// 		this.sendMode = this.betService.sendMode.id;
						// 	}
						// }
						if (!(this.empresa && this.empresa.coderequired && this.empresa.donacion < 0)) {
							this.saldoInsuficienteBet(nuevoSaldo);
						}
					}
					else {
						if (this.betService.sendMode) {
							if (this.betService.sendMode.id > 1 && this.betService.sendMode.id != 5 && !this.betService.sendMode.sede) {
								if (!this.user.adress || !this.user.city || !this.user.cp || !this.user.province || !this.user.phone) {
									this.toastrService.error('Introduce los datos de envío');
									return;
								}
								this.sendMode = this.betService.sendMode.id;
							}

							this.OpenDialogCompra()
						}
						else {
							this.OpenDialogCompra()
						}
					}
				} else {

					let nuevoSaldo = this.saldoCliente - this.betService.cost;
							if (this.guinda) {
								nuevoSaldo -= this.guindaCost;
							}

					if (nuevoSaldo < 0 || this.saldoCliente == 0) {
						// if (this.betService.sendMode) {
						// 	if (this.betService.sendMode.id > 1 && this.betService.sendMode.id != 5 && !this.betService.sendMode.sede) {
						// 		if (!this.user.adress || !this.user.city || !this.user.cp || !this.user.province || !this.user.phone) {
						// 			this.toastrService.error('Introduce los datos de envío');
						// 			return;
						// 		}
						// 		this.sendMode = this.betService.sendMode.id;
						// 	}

						// }
						this.saldoInsuficienteBet(nuevoSaldo);
					}
					else {
						if (this.betService.sendMode) {
							if (this.betService.sendMode.id > 1 && this.betService.sendMode.id != 5 && !this.betService.sendMode.sede) {
								if (!this.user.adress || !this.user.city || !this.user.cp || !this.user.province || !this.user.phone) {
									this.toastrService.error('Introduce los datos de envío');
									return;
								}
								this.sendMode = this.betService.sendMode.id;
							}

							this.OpenDialogCompra()
						}
						else {
							this.OpenDialogCompra()
						}
					}
				}

			}
			else {
				localStorage.setItem("last-url", this.router.url)

				if (this.betService.empresa != null) {
					localStorage.setItem("empresa", JSON.stringify({
						"empresa_id": this.betService.empresa.id,
						"bets": this.betService.bets,
						"envio_id": this.betService.sendMode != null ? this.betService.sendMode.id : 1,
						"slug": this.betService.empresa.slug,
						"importe": Number(this.betService.cost) + Number(this.betService.guindaPrice),
						"leguinda": this.betService.guinda,
						"guindaprice": this.betService.guindaPrice,
						"days": this.betService.empresa.sorteo_asociado.fecha
					}));
				}

				this.router.navigate(['cliente/menu']);
			}
		}
		else {
			this.betService.setBets(this.betService.bets, 'games-footer');
			this.clickEvent.emit(true)
		}
	}

	loginAzure() {
		let texto = "Su empresa requiere hacer login con azure para poder comprar. Desea continuar?";

		const dialog = this.dialog.open(modalYesNoComponent, {
			panelClass: 'modal-custom',
			data: {
				title: 'Login con Azure',
				texto,
				buttonConfirm: 'Continuar',
				btnConfirmColor: 'blue',
				buttonCancel: 'Cancelar',
				showIcon: false,
				showOptionCheck: false
			}
		})
		localStorage.setItem('azureadlogin', this.betService.empresa.slug);
		dialog.afterClosed().subscribe(res => {
			if (res) {
				this.azureService.login();
			}
			else {
				this.router.navigate(['cliente/loteriaempresas']);
			}
		})
	}

	private OpenDialogCompra() {
		let nuevoSaldo = this.saldoCliente - this.betService.cost;
		//Establecemos los datos del modal / set data to alert modal
		let texto = "Esta jugada tiene un coste de:</br></br>";
		let coste = this.betService.cost;
		if (this.guinda) {
			coste += this.guindaCost
			nuevoSaldo -= this.guindaCost
		}

		texto += "<h2 class='currency'>" + coste + " €</h2></br>";
		texto += "Saldo restante: <strong>" + Math.round(nuevoSaldo * 100) / 100 + " €</strong>";

		if (this.freeBeet) {
			var alertDialog = this.dialog.open(modalAlertaComponent, {
				panelClass: 'modal-custom',
				data: {
					title: 'Confirmar Jugada',
					texto: "Esta jugada no tiene coste ¡¡ES GRATIS!!",
					buttonConfirm: 'Aceptar',
					showOptionCheck: true
				}
			});
		}
		else {
			var alertDialog = this.dialog.open(modalAlertaComponent, {
				panelClass: 'modal-custom',
				data: {
					title: 'Confirmar Jugada',
					texto,
					buttonConfirm: 'Pagar jugada',
					showOptionCheck: true
				}
			});
		}

		alertDialog.afterClosed().subscribe(res => {
			if (res) {
				if (this.freeBeet) {
					this.playFreeService.invitadoJugaGratis.pipe(take(1)).subscribe(res => {
						if (res.movil != this.user.phone)
							this.checkSecurity()
					})
				}
				else
					this.checkSecurity();
			}
		});
	}

	checkSecurity() {
		if (!this.grupo_id) {
			this.userService.getSeguridad().subscribe((res) => {
				if (res.status == 200) {
					if (res.data.compra_producto) {
						let checkPinDialog = this.dialog.open(modalPinComponent, {
							panelClass: 'modal-custom',
							disableClose: true,
							data: {
								'title': "Escribe tu PIN de Seguridad",
								'mode': "Check",
								'parameters': null
							}
						});
						return checkPinDialog.afterClosed().subscribe((res) => {
							if (res == true) {
								this.playBetAux();
							}
						});
					}
					else {
						this.playBetAux();
					}
				}
				else {
					this.playBetAux();
				}
				return false;
			});
		}
		else {
			this.playBetAux();
		}
	}

	playBetAux() {
		if (this.betService.addedDays.length == 0) {
			this.toastrService.error('Debe seleccionar un sorteo.');
			return;
		}
		let preference = localStorage.getItem('laguinda');
		if (preference == 'true' || preference == 'false') {
			localStorage.setItem('laguinda', (this.guinda ? 'true' : 'false'));
		}
		let aux = false;
		if (this.betService.options.idGame === 1) {
			this.betService.bets.forEach(element => {
				if (element.numbersChecked.length >= 5 || element.numbersChecked.length == 0)
					aux = true
				else {
					aux = false
					return
				}
			});
		}

		if ((this.betService.options.idGame === 11 && this.betService.simpleBet && this.betService.bets.length < 2)
			|| (this.betService.options.idGame === 1 && !aux)) {
			this.toastrService.error('Debe rellenar una apuesta valida para poder comprar.');
		} else {
			this.loading = true;
			this.betService.setLoading(true);
			this.disabled = true;
			console.log("Estoy Aquí");
			this.betService.playBet()?.subscribe({
				next: (res: any) => {
					console.log("Aquí no");
					if (res.status == 200) {
						if (this.betService.freeBet) {
							this.playFreeService.addIntivado(res.data).subscribe((res3: any) => {
							});
						}
		
						//Actualizamos el salo del usuario
						let guindaAux = 0
						if (this.guinda)
							guindaAux = this.guindaCost
		
						this.userService.setSaldo(this.saldoCliente - (this.cost + guindaAux))
		
						this.betService.getPlayData(res.data).subscribe((res2: any) => {
		
							const betId = res2[0].apuestas[0].jugada_id;
		
							//Obtenemos el pedido id
							let pedido_id = res2[0].pedido_id;
		
							let paramFireBase = {
								transaction_id: pedido_id,
								currency: 'EUR',
								GAME_ID: this.betService.options.idGame,
								PLAYS_AMOUNT: this.betService.bets.length,
								IS_SUCCESSFUL: true,
								METHOD: "SIMPLE",
								CLIENT_ID: res2[0].cliente_id,
								value: this.betService.cost
							}
		
							if (this.grupo_id)
								paramFireBase.CLIENT_ID = this.grupo_id;
								paramFireBase.METHOD = "GRUPO";
		
							if (environment.production) {
								if (this.betService.freeBet)
									logEvent(this.analytics, "FREE_PLAY_STARTED", paramFireBase)
								else {
									if (this.betService.empresa) {
										paramFireBase.METHOD = "EMPRESA";
										logEvent(this.analytics, "purchase", paramFireBase);
									}
									else {
										logEvent(this.analytics, "purchase", paramFireBase)
										if (this.betService.abono) {
											logEvent(this.analytics, "subscribe");
										}
									}
								}
							}
		
							if (!this.grupo_id) {
								if (this.betService.options.idGame != 6 && this.betService.options.idGame != 7 && this.betService.options.idGame != 8)
									this.router.navigateByUrl('/cliente/jugadas/' + betId);
								else {
									if (this.betService.multiPlayBetLottery)
										this.router.navigateByUrl('/cliente/jugadas')
									else
										this.router.navigateByUrl('/cliente/jugadas/' + betId);
								}
							}
							else {
								this.grupoService.get_grupo(this.grupo_id).subscribe((res4: Mygroup) => {
									this.grupoService.set_group(res4)
		
									if (this.betService.options.idGame != 6 && this.betService.options.idGame != 7 && this.betService.options.idGame != 8)
										this.router.navigateByUrl('/cliente/mis-grupos/detalles/' + this.grupo_id + "/" + res4.nombre + "/jugada/" + betId);
									else {
										if (this.betService.multiPlayBetLottery)
											this.router.navigateByUrl('/cliente/mis-grupos/detalles/' + this.grupo_id + "/" + res4.nombre + "/boletos")
										else
											this.router.navigateByUrl('/cliente/mis-grupos/detalles/' + this.grupo_id + "/" + res4.nombre + "/jugada/" + betId);
									}
								})
		
		
							}
		
						});
					}
					else {
						this.toastrService.error(res.u_message);
						this.betService.setLoading(false);
						this.loading = false;
						this.disabled = false;
					}
				},
				error: (error: any) => {
					let errorMessage = "Se produjo un error al realizar la compra, Por favor intentelo de nuevo mas tarde"

					if (this.betService.empresa) {
						if (error.error.indexOf("No tiene permitido comprar mas decimos de uno de los numeros") >= 0) //Chapuzero pero hay que mejorar las respuestas de la api
							errorMessage = "Upss!!! Tu empresa ha limitado el número de décimos que puede comprar cada persona, y ya has alcanzado el maximo."
					}

					this.toastrService.error(error.error);
					this.betService.setLoading(false);
					this.loading = false;
					this.disabled = false;

					let paramFireBase = {
						CLIENT_ID: this.cliente_id
					}
					logEvent(this.analytics, "PLAY_INTENDED", paramFireBase)
				}
			});
		}
		//this.betService.setLoading(true);
	}

	ngOnDestroy() {
		this.guindaSub.unsubscribe()
		this.guindaPriceSub.unsubscribe()
		this.optionsSub.unsubscribe()
		this.footerService.set_Show_footer(true)

		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe((x: NavigationEnd) => {
			if (this.sendMode != 4) //Reseteamos el betservice en caso de que no sea forma de envio 24 horas
			{
				if (!x.url.includes("grupos"))
					this.headerService.set_modeGrupoCool(false);

				this.betService.clearData();
				this.betService.setGrupoId(0);
				this.betService.setEmpresa(undefined);
				this.betService.clearSendMode();
				this.betService.setFreeBet(false)
				this.playFreeService.setInvitadoJugadaGratis(null)
				this.betService.setLoading(false);
				this.betService.setGuinda(false);
				this.betService.setGuindaPrice(0);
			}
		})
	}

}
